<template>
  <el-carousel :height="UI.clientWidth / 3 + 'px'">
    <el-carousel-item v-for="(item, index) in headPics" :key="item.src">
      <img
        :class="item.url ? 'cursor-pointer' : ''"
        @click="toUrl(item.url)"
        class="full-width"
        :src="item.src"
      />
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import { getHeadPicList } from '@/servers/homepage.js';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      headPics: [],
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  created() {
    let that = this;
    getHeadPicList({}, function(res) {
      that.headPics = res.items;
    });
  },

  methods: {
    toUrl: function(url) {
      if (url) {
        window.open(url, '_blank');
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/index/home/headPic.vue